import { useState } from "react";
import { ContactAPI } from "../../api";

const data = {
	email: "",
};
const NewsLetter = () => {
	const [successMessage, setSuccessMessage] = useState(false);
	const [formData, setFormData] = useState(data);

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData((prev) => ({ ...prev, [name]: value }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		const payload = formData;
		try {
			await ContactAPI.submitSubscribeForm(payload);
			setSuccessMessage(true)
			setFormData({
				email: "",
			});
		} catch (err) {
			const serverErrors = err?.response?.data?.errors;
			const fallbackMessage =
				err?.response?.data?.message || err.message || "Something went wrong";

			const messages = Object.entries(serverErrors || {}).flatMap(
				([field, msgs]) => msgs.map((msg) => `${field}: ${msg}`)
			);

			alert(messages.length ? messages.join("\n") : fallbackMessage);
		}
	};

	return (
		<>
			{!successMessage && (
				<div className="footer-form">
					<input
						placeholder="Email address"
						name="email"
						onChange={handleChange}
						type="email"
					/>

					<button onClick={handleSubmit}>Submit</button>
				</div>
			)}
			{successMessage && <p className="text-success">Thanks for subscribing! You're all set to receive updates.</p>}
		</>
	);
};
export default NewsLetter;
